import { useMutation, useQueryClient } from "@tanstack/react-query";
import { restoreSupplier } from "../../api/apiSuppliers";
import toast from "react-hot-toast";

const useRestoreSupplier = () => {
    const queryClient = useQueryClient();

    const { mutate: restoreSupplierMutate, isPending } = useMutation({
        mutationFn: restoreSupplier,
        onSuccess: (res) => {
            toast.success(res.message || "Supplier restored successfully");
            queryClient.invalidateQueries({ queryKey: ["suppliers"] });
        },
        onError: (error) => {
            toast.error(error.response?.data?.message || "Failed to restore supplier");
        },
    });

    return { restoreSupplierMutate, isPending };
};

export default useRestoreSupplier;
